import { Injectable } from '@angular/core';

import tag from '@bytel/bytel-tag-commander';

import { ENV_LIST } from '@app/interfaces/config.interface';

import { Oauth2Service, StorageService } from '@common';

// @TODO: Move interface to models folder
interface BasicObj {
    [key: string]: any;
}

@Injectable({
    providedIn: 'root',
})
export class BytelTagService {
    protected settings: BasicObj = {};
    protected initialized: boolean;
    private currentEtapeEcommerce: string;
    constructor(protected oauth2: Oauth2Service, protected storageService: StorageService) {}

    /**
     * Bare settings for Tag service
     * @param options
     */
    protected setup(options: BasicObj = {}) {
        this.settings = {
            // Website API url
            host: window.ConfigInitial?.oauth?.resourceUrl, // Api env execution
            env: window.ConfigInitial?.environment, // App name which use the lib
            site: 'magento', // debug, enable by default on LOCAL env, but can be disable with provided options
            debug: window.ConfigInitial?.environment !== ENV_LIST.PRODUCTION,
            shouldEmitEvent: true,
            hasHistory: true,
        };

        if (this.oauth2.isConnected) {
            this.oauth2.autoLogin();
            this.settings.oauth = {
                idToken: this.oauth2._id_token,
                accessToken: this.oauth2.access_token,
            };
        } else {
            this.settings.oauth = {
                callback: `${window.location.origin}/skin/frontend/bytel/default/template/oauth-callback.html`,
                clientId: 'magento.web.bouyguestelecom.fr',
                url: window.ConfigInitial?.oauth?.baseUrl,
            };
        }

        this.settings = {
            ...this.settings,
            options,
        };
    }

    /**
     * Push data to Tags service
     * @param data
     */
    public send(data: BasicObj) {
        const tagService = tag;

        if (!tagService) {
            console.error('Tag package is not defined');
            return;
        }
        if (!data || !Object.keys(data).length) {
            console.error('Please provide some data for tag service');
            return;
        }

        data.env = data.env || window.ConfigInitial?.environment;
        data.site = this.storageService.get('yama_cart', false) ? 'Partenaire_cfcm_boutique' : 'Boutique';
        data.univers = data.univers || window.tc_vars.univers;
        data.parcours = data.parcours || window.tc_vars.parcours;
        data.url = data.url || window.location.href;
        data.etapeEcommerce = data.etapeEcommerce || this.currentEtapeEcommerce;
        data.variablesSpecifiques = {
            ...data?.variablesSpecifiques,
            ...{ version: window.ConfigInitial?.version },
        };

        this.currentEtapeEcommerce = data.etapeEcommerce;

        const sendToTagService = () => {
            tagService.send(data).then(() => {
                if (this.settings.debug) {
                    console.table(data);
                }
            });
        };

        this.updateTrackingVars(data);

        if (!this.initialized) {
            this.setup();
            tagService.setup(this.settings).then(() => {
                this.initialized = true;
                sendToTagService();
            });
        } else {
            sendToTagService();
        }
    }

    private updateTrackingVars(data: BasicObj) {
        window.tc_vars = { ...window.tc_vars, ...data };
    }

    /**
     * Filter string before sending tag
     * @param data
     */
    public filter(str: string) {
        return str
            .split(' ')
            .join('_')
            .split('é')
            .join('e')
            .split('è')
            .join('e')
            .split('ê')
            .join('e')
            .split('à')
            .join('a');
    }
}
